import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonModal } from '@ionic/react'
import { storeMobx } from 'restaurant'
import { map } from '@dt/fe-utils/dist/lodash'
import { format, ddayjs } from '@dt/fe-utils'
import { mktConfigMobx } from '@mobxStore'
import { useMktConfigInit } from '@common/hooks'
import ActivityApi from 'api/activity.api'
import './index.scss'

interface IProps {
  type: 'get' | 'use';
  couponInfo: any;
  reject?: () => void;
  resolve?: () => void;
}

const CouponDetailModal: FC<IProps> = (props: IProps) => {
  const {
    type,
    couponInfo,
    reject,
    resolve,
  } = props
  const { storeList, storeIdToStore } = storeMobx
  const [products, setProducts] = useState<any[]>([])
  const [comboProducts, setComboProducts] = useState<any[]>([])
  const [stores, setStores] = useState<any[]>([])
  const [storeType, setStoreType] = useState<boolean>(true)
  const [productType, setProductType] = useState<boolean>(true)
  const [comboProductType, setComboProductType] = useState<boolean>(true)
  const [weekTime, setWeekTime] = useState<string[]>([])
  const renderProductName = (product) => {
    if (product.productName) {
      const str = product.productName
      if (product.scaleName) {
        return `${str}(${product.scaleName})`
      }
      return str
    }
  }

  useMktConfigInit(true)

  useEffect(() => {
    if (couponInfo) {
      if (couponInfo.type !== 'cash') {
        ActivityApi.getCouponProducts(couponInfo.couponId).then((res: any) => {
          if (!res.error) {
            res.products?.length && setProducts(res.products.map(renderProductName))
            res.comboProducts?.length && setComboProducts(res.comboProducts.map(renderProductName))
          }
        })
      } else {
        setProducts([])
      }
      if (couponInfo.isAllStore) {
        setStores(map(storeList, (i: any) => i.storeName))
      } else {
        setStores(map(couponInfo.storeIds, (item: number) => {
          return storeIdToStore[item]?.storeName || ''
        }))
      }
      if (!couponInfo.isAllTime && couponInfo.timeRangeType === 'week') {
        const newTimeRange = []
        couponInfo.timeRanges.forEach((item: any) => {
          if (item.isOpen) {
            const newItem = { day: item.weekDay === 0 ? 7 : item.weekDay, list: [] }
            item.ranges.forEach((time: any) => {
              newItem.list.push({ begin: time.startTime, end: time.endTime })
            })
            newTimeRange.push(newItem)
          }
        })
        newTimeRange.length && setWeekTime(format.toSaleTime(newTimeRange, bo === 'cn' ? '24' : '12').filter(item => item.indexOf(i18n.t('store.notInSale')) === -1))
      }
    }
  }, [couponInfo])
  useEffect(() => {
    const storeContent = document.getElementById('storeContent') as any
    if (storeContent) {
      if (storeContent.offsetHeight > 90) {
        setStoreType(false)
      } else {
        setStoreType(true)
      }
    }
  }, [stores])
  useEffect(() => {
    const productContent = document.getElementById('productContent') as any
    if (productContent) {
      if (productContent.offsetHeight > 90) {
        setProductType(false)
      } else {
        setProductType(true)
      }
    }
  }, [products])
  useEffect(() => {
    const comboProductContent = document.getElementById('comboProductContent') as any
    if (comboProductContent) {
      if (comboProductContent.offsetHeight > 90) {
        setComboProductType(false)
      } else {
        setComboProductType(true)
      }
    }
  }, [comboProducts])

  return (
    <IonModal
      cssClass='coupon-detail-modal'
      isOpen
      showBackdrop
      backdropDismiss
      onDidDismiss={reject}
    >
      <div className='modal-body'>
        <div data-cypid='mmgCouponBack' className='coupon-detail-back' onClick={resolve}><i className='iconfont icon-BACK-12x'></i></div>
        <div className='coupon-detail-area'>
          {couponInfo.picture && <div className='coupon-detail-bg' style={{ backgroundImage: `url(${couponInfo.picture})` }}></div>}
          <div className='coupon-detail-title'>
            <div className='coupon-detail-title-top'>{couponInfo.couponName}</div>
            <div>
              {couponInfo.type === 'cash' && i18n.t('mkt.coupon.cashDeductionDetail', { fee: format.toPrice(couponInfo.discountValue) })}
              {couponInfo.type === 'item' &&
                <>
                  {couponInfo.discountType === 'discountFee' && i18n.t(`mkt.coupon.${couponInfo.discountType}ItemDetail`, { fee: format.toPrice(couponInfo.discountValue) })}
                  {couponInfo.discountType === 'discountRate' && i18n.t(`mkt.coupon.${couponInfo.discountType}ItemDetail`, { fee: format.toDiscount('discountRate', couponInfo.discountValue) })}
                  {couponInfo.discountType === 'specialOffer' && i18n.t(`mkt.coupon.${couponInfo.discountType}ItemDetail`, { fee: format.toPrice(couponInfo.discountValue) })}
                </>}
              {(couponInfo.type === 'order' || couponInfo.type === 'designate') &&
                <div>
                  {couponInfo.discountType === 'discountFee' && i18n.t(`mkt.coupon.${couponInfo.discountType}OrderDetail`, { orderFee: format.toPrice(couponInfo.orderFee), discountFee: format.toPrice(couponInfo.discountValue) })}
                  {couponInfo.discountType === 'discountRate' && i18n.t(`mkt.coupon.${couponInfo.discountType}OrderDetail`, { orderFee: format.toPrice(couponInfo.orderFee), discountFee: format.toDiscount('discountRate', couponInfo.discountValue) })}
                </div>}
              {
                couponInfo.type === 'ladder' &&
                  <div>
                    {i18n.t('mkt.coupon.discountFeeItem')}
                  </div>
              }
            </div>
          </div>
          <div className='coupon-detail-line'></div>
          <div className='coupon-detail-info'>
            <div className='info-item info-item-top'>
              <div className='info-item-top-left'>
                <div className='info-item-top'>
                  {type === 'get' ? i18n.t('mkt.coupon.effectiveTime') : i18n.t('mkt.giftCard.validPeriod')}
                </div>
                <div className='info-item-content'>
                  {type === 'get' && couponInfo.whenEffect === 'today' && <>{i18n.t('mkt.coupon.useType1')}（{couponInfo.effectDay === null ? i18n.t('mkt.giftCard.useRuleExpired1') : i18n.t('mkt.coupon.validDays', { day: couponInfo.effectDay })}）</>}
                  {type === 'get' && couponInfo.whenEffect === 'tomorrow' && <>{i18n.t('mkt.coupon.useType2')}（{couponInfo.effectDay === null ? i18n.t('mkt.giftCard.useRuleExpired1') : i18n.t('mkt.coupon.validDays', { day: couponInfo.effectDay })}）</>}
                  {type === 'get' && couponInfo.whenEffect === 'specify' && <>{format.toMonthDateYear(couponInfo.startTime)} {i18n.t('mkt.common.to')} {couponInfo.effectDay === null ? i18n.t('mkt.giftCard.useRuleExpired1') : format.toMonthDateYear(ddayjs(couponInfo.startTime).add(couponInfo.effectDay - 1, 'days').valueOf())}</>}
                  {type === 'use' && <>{`${format.toMonthDateYear(couponInfo.startTime)} ${i18n.t('mkt.common.to')} `}{(couponInfo.effectDay === null || couponInfo?.endTime >= '3000-01-01 00:00:00') ? i18n.t('mkt.giftCard.useRuleExpired1') : couponInfo.endTime ? format.toMonthDateYear(ddayjs(couponInfo.endTime).valueOf() - 1) : format.toMonthDateYear(ddayjs(couponInfo.startTime).add(couponInfo.effectDay - 1, 'days').valueOf())}</>}
                </div>
              </div>
              <div className='info-item-top-right'>
                <div className='info-item-top'>{i18n.t('mkt.pointCard.channel')}</div>
                <div className='info-item-content'>
                  {couponInfo.channelEatType && !couponInfo.channelEatType.isAll
                    ? couponInfo.channelEatType.channels.map((item: any) => {
                      if (item.enable) {
                        return mktConfigMobx.eatTypeAndChannelMap[item.key]?.value || item.key
                      } else {
                        return ''
                      }
                    }).filter((item: any) => !!item).join(',')
                    : i18n.t('mkt.market.allChannels')}
                </div>
              </div>
            </div>
            {
              (products.length > 0 || couponInfo.productRelation === 'all') &&
                <div className='info-item'>
                  <div className='info-item-top'>
                    {
                      couponInfo.business === 'mall'
                        ? (couponInfo.productRelation === 'excluded' ? i18n.t('mkt.coupon.noApplicableMall') : i18n.t('mkt.coupon.applicableMall'))
                        : (couponInfo.productRelation === 'excluded' ? i18n.t('mkt.coupon.noApplicableMeals') : i18n.t('mkt.coupon.applicableMmeals'))
                    }
                  </div>
                  <div className={`info-item-content${!productType ? ' info-item-content-more' : ''}`} id='productContent'>
                    {!productType && <div data-cypid='mmgClickCouponProduct' className='info-item-content-show' onClick={() => setProductType(!productType)}>{i18n.t('cart.out')}<i className='iconfont icon-jiantou'></i></div>}
                    {
                      couponInfo.productRelation === 'all'
                        ? (couponInfo.business === 'mall' ? i18n.t('mkt.coupon.allMallApplicable') : i18n.t('mkt.coupon.allMealApplicable'))
                        : (products.join('、'))
                    }
                  </div>
                </div>
            }
            {
              (comboProducts.length > 0 || couponInfo.productComboRelation === 'all') && couponInfo.business === 'meal' &&
                <div className='info-item'>
                  <div className='info-item-top'>{couponInfo.productComboRelation === 'excluded' ? i18n.t('mkt.coupon.noApplicableCombo') : i18n.t('mkt.coupon.applicableCombo')}</div>
                  <div className={`info-item-content${!comboProductType ? ' info-item-content-more' : ''}`} id='comboProductContent'>
                    {!comboProductType && <div data-cypid='mmgClickCouponCombo' className='info-item-content-show' onClick={() => setComboProductType(!comboProductType)}>{i18n.t('cart.out')}<i className='iconfont icon-jiantou'></i></div>}
                    {
                      couponInfo.productComboRelation === 'all'
                        ? (i18n.t('mkt.coupon.allComboApplicable'))
                        : (comboProducts.join('、'))
                    }
                  </div>
                </div>
            }
            {
              ['item', 'ladder'].includes(couponInfo.type) && couponInfo.business === 'meal' &&
                <div className='info-item'>
                  <div className='info-item-top'>{i18n.t('mkt.coupon.dosingIsApplicable')}</div>
                  <div className='info-item-content'>{couponInfo.isIncludeModifier ? i18n.t('mkt.coupon.dosingApplicable') : i18n.t('mkt.coupon.dosingNotApplicable')}</div>
                </div>
            }
            <div className='info-item'>
              <div className='info-item-top'>{i18n.t('mkt.coupon.availabilityPeriod')}</div>
              <div className='info-item-content'>
                {couponInfo.isAllTime && i18n.t('mkt.coupon.allTimeApplicable')}
                {!couponInfo.isAllTime && couponInfo.timeRangeType === 'month' && i18n.t('mkt.coupon.monthTimeRange', { days: couponInfo.timeRanges.map((day: any) => day.monthDay).join('、') })}
                {!!weekTime.length && weekTime.map(item => { return <div key={item}>{item}</div> })}
              </div>
            </div>
            {
              stores.length > 0 &&
                <div className='info-item'>
                  <div className='info-item-top'>{i18n.t('mkt.member.applyStore')}:</div>
                  <div className={`info-item-content${!storeType ? ' info-item-content-more' : ''}`} id='storeContent'>
                    {!storeType && <div data-cypid='mmgClickCouponStore' className='info-item-content-show' onClick={() => setStoreType(!storeType)}>{i18n.t('cart.out')}<i className='iconfont icon-jiantou'></i></div>}
                    {couponInfo.isAllStore ? i18n.t('mkt.member.allStore') : stores.join('、')}
                  </div>
                </div>
            }
            {
              couponInfo.description &&
                <div className='info-item'>
                  <div className='info-item-top'>{i18n.t('mkt.coupon.description')}</div>
                  <div className='info-item-content'>{couponInfo.description}</div>
                </div>
            }
          </div>
        </div>
      </div>
    </IonModal>
  )
}

export default observer(CouponDetailModal)
